// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import FormField from './../../../components/controls/FormField';
import ValidationInput from './../../../components/controls/ValidationInput';
import UserProfileActions from './../actions/UserProfileActions';
import CommonMessages from '../../../common/CommonMessages';
declare var InovxLoader:any;

interface ChangeUserPasswordProps {
    onPasswordChanged: () => void;
    onCancel: () => void;
}

interface ChangeUserPasswordState {
    validation: IValidationDictionaryObject;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

function getBlankValidation(): IValidationObject {
    return { invalidInput: false, invalidValue: false, invalidInputMessage: "", invalidValueMessage: "" };
}

class ChangeUserPassword extends React.Component<ChangeUserPasswordProps, ChangeUserPasswordState> {
    private _user: any = {};
    constructor(props: ChangeUserPasswordProps, context: any) {
        super(props, context);

        this.state = {
            validation: {
                "OldPassword": getBlankValidation(),
                "NewPassword": getBlankValidation(),
                "ConfirmPassword": getBlankValidation()
            },
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
        };
    }

    private _changePassword = () => {
        if (this._validatePassword()) {
            this.setState({} as any);

            var that = this;

            UserProfileActions.updatePassword(this.state.oldPassword, this.state.newPassword, this.props.onPasswordChanged,
                (error: IServiceErrorObject) => {
                    if (error.messageObj.propertyName) {
                        that.state.validation[error.messageObj.propertyName].invalidValue = true;
                        that.state.validation[error.messageObj.propertyName].invalidValueMessage = error.messageObj.message;
                        that.setState(that.state);
                    }
                });
        } else {
            this.setState({} as any);
        }
    }

    private _validatePassword = () => {
        var oldPass = this._validateOldPassword(this.state);
        var newPass = this._validateNewPassword(this.state);
        var confirmPass = this._validateConfirmPassword(this.state);

        return (oldPass && newPass && confirmPass);
    }

    private _validateOldPassword = (state: ChangeUserPasswordState) => {
        if (!state.oldPassword) {
            state.validation["OldPassword"].invalidValueMessage = CommonMessages.Validation.Required;
            state.validation["OldPassword"].invalidValue = true;

            return false;
        } else {
            state.validation["OldPassword"].invalidValue = false;
            return true;
        }
    }

    private _validateNewPassword = (state: ChangeUserPasswordState) => {
        if (state.newPassword === state.confirmPassword) {
            state.validation["ConfirmPassword"].invalidValue = false;
        }

        if (!state.newPassword) {
            state.validation["NewPassword"].invalidValueMessage = CommonMessages.Validation.Required;
            state.validation["NewPassword"].invalidValue = true;

            return false;
        } else if (state.newPassword == state.oldPassword) {
            state.validation["NewPassword"].invalidValueMessage = InovxLoader.t("UserProfile:form.cannotBeSamePassword");
            state.validation["NewPassword"].invalidValue = true;

            return false;
        } else {
            state.validation["NewPassword"].invalidValue = false;
            return true;
        }
    }

    private _validateConfirmPassword = (state: ChangeUserPasswordState) => {
        if (!state.newPassword) {
            state.validation["ConfirmPassword"].invalidValueMessage = CommonMessages.Validation.Required;
            state.validation["ConfirmPassword"].invalidValue = true;

            return false;
        }  else if (state.newPassword !== state.confirmPassword) {
            state.validation["ConfirmPassword"].invalidValueMessage = InovxLoader.t("UserProfile:form.passwordMustMatch");
            state.validation["ConfirmPassword"].invalidValue = true;

            return false;
        } else {
            state.validation["ConfirmPassword"].invalidValue = false;

            return true;
        }
    }

    private _onOldPasswordChanged = (event: any) => {
        this.setState({ oldPassword: event.target.value });
        this.setState((state) => {
            this._validateOldPassword(state);
            return state;
        });
    }

    private _onNewPasswordChanged = (event: any) => {
        this.setState({ newPassword: event.target.value });
        this.setState((state) => {
            this._validateNewPassword(state);
            return state;
        });
    }

    private _onConfirmChanged = (event: any) => {
        this.setState({ confirmPassword: event.target.value });
        this.setState((state) => {
            this._validateConfirmPassword(state);
            return state;
        });
    }

    render() {

        var passwordInput = {
            className: 'form-control',
            type: 'password',
            name: 'Password'
        };

        return (
            <div className="panel panel-primary profile-change-password">
                <div className="panel-heading">{InovxLoader.t('UserProfile:form.changePasswordHeader')}</div>
                <div className="panel-body fc-margin">

                    <FormField title={`${InovxLoader.t("UserProfile:form.oldPassword")}*`} inputName='OldPassword'>
                        <ValidationInput {...passwordInput} value={this.state.oldPassword} onChange={this._onOldPasswordChanged} validation={this.state.validation["OldPassword"]} autocomplete="current-password" />
                    </FormField>

                    <FormField title={`${InovxLoader.t("UserProfile:form.newPassword")}*`} inputName='NewPassword'>
                        <ValidationInput {...passwordInput} value={this.state.newPassword} onChange={this._onNewPasswordChanged} validation={this.state.validation["NewPassword"]} autocomplete="new-password" />
                    </FormField>

                    <FormField title={`${InovxLoader.t("UserProfile:form.confirmPassword")}*`} inputName='ConfirmPassword'>
                        <ValidationInput {...passwordInput} value={this.state.confirmPassword} onChange={this._onConfirmChanged} validation={this.state.validation["ConfirmPassword"]} autocomplete="new-password" />
                    </FormField>

                    <div className="btn-bar-b-sm">
                        <button type="button" className="btn btn-primary" onClick={this._changePassword}>{InovxLoader.t('UserProfile:form.changePassword') }</button>
                        <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{InovxLoader.t('UserProfile:form.cancel')}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangeUserPassword;